import request from 'superagent';

class FileManager
{
    static uploadFile(blob, routePath, token)
    {
        const contentType = blob.type

        //returns a thenable object with resp from Google
        return request
        .get(routePath)
        .send({})
        .accept('application/json')
        .query({content_type: contentType})
        .set('Content-Type', 'application/json')
        .set('Authorization', 'Bearer ' + token)
        .then((res) => {
            const uploadUrl = res.body.upload_url;
            return request
            .put(uploadUrl)
            .set('Content-Type', contentType)
            .send(blob)
        })
    }

    static dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}
}
export default FileManager;



// WEBPACK FOOTER //
// ./src/lib/FileManager.js